import { render } from "./DatabasePicker.vue?vue&type=template&id=32432f99&scoped=true"
import script from "./DatabasePicker.vue?vue&type=script&lang=js"
export * from "./DatabasePicker.vue?vue&type=script&lang=js"

import "./DatabasePicker.vue?vue&type=style&index=0&id=32432f99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32432f99"],['__file',"src/components/DatabasePicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32432f99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32432f99', __exports__)) {
    api.reload('32432f99', __exports__)
  }
  
  module.hot.accept("./DatabasePicker.vue?vue&type=template&id=32432f99&scoped=true", () => {
    api.rerender('32432f99', render)
  })

}


export default __exports__